
import {
  Vue,
  Component,
  Watch,
  Ref,
  Prop,
} from 'vue-property-decorator';
import {
  Dialog,
  Button,
  Row,
  Col,
  Form,
  FormItem,
  Input,
  Select,
  Option,
} from 'element-ui';
import {
  log,
} from 'util';

import examApi from '@/api/exam';
import addOrModifyCommon from '../../../../components/common/addOrModifyCommon.vue';
@Component({
  components: {
    Dialog,
    Button,
    Row,
    Col,
    addOrModifyCommon,
    Form,
    FormItem,
    Input,
    Select,
    Option,
  },
})
export default class addOrModify extends Vue {
  @Ref('questionForm') readonly questionFormView!: Form;

  @Prop() echoData: any;

  @Prop() backCallback!: Function;

  @Prop() courseType!: Array<any>;

  @Watch('echoData')
  onEchoChange(newValue: any, oldValue: any) {
    if (newValue && Object.keys(newValue).length > 0) {
      Object.assign(this.questionForm, newValue);
    } else {
      this.resetForm();
    }
  }

  private questionForm: any = {
    id: '',
    // subjectId: '',
    subjectName: '',
    subjectRemark: '',
    serial: '',
  };

  private title: string = '试卷添加';

  private isNeedAddOrModify = false;

  private isLoading = false;

  private rules: any = {
    subjectId: [{
      required: true,
      message: '请选择题库课程类型',
    }],
    subjectName: [{
      required: true,
      message: '请输入题库名称',
    }],
  };

  back() {
    this.backCallback();
  }

  resetForm() {
    this.questionFormView.resetFields();
    // eslint-disable-next-line no-return-assign
    Object.keys(this.questionForm).forEach(key => this.questionForm[key] = '');
  }

  submitForm() {
    this.questionFormView.validate((isSuccess: boolean) => {
      if (isSuccess) {
        this.isLoading = true;
        if (this.questionForm.id) {
          examApi.modifyQuesBank(this.questionForm).then(() => {
            this.submitSuccessThenToDo();
            /* eslint-disable no-return-assign */
          }).catch(() => (this.isLoading = false));
        } else {
          this.questionForm.id = null;
          examApi.addQuesBank(this.questionForm).then(() => {
            this.submitSuccessThenToDo();
          /* eslint-disable no-return-assign */
          }).catch(() => (this.isLoading = false));
        }
      }
    });
  }

  submitSuccessThenToDo() {
    this.resetForm();
    this.isLoading = false;
    this.back();
  }
}
